const initialState = {
  categories: [],
};
const categoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_CATEGORY_SUCCESS":
      return {
        ...state,
        categories: action.payload,
      };
    case "ADD_CATEGORY_SUCCESS":
      return {
        ...state,
        categories: [action.payload, ...state.categories],
      };
    case "UPDATE_CATEGORY_SUCCESS":
      return {
        ...state,
        categories: state.categories.map((category) =>
          category.id === action.payload.id
            ? { ...category, ...action.payload }
            : category
        ),
      };
    case "DELETE_CATEGORY_SUCCESS":
      return {
        ...state,
        categories: state.categories.filter(
          (category) => category.id !== action.payload
        ),
      };
    default:
      return {
        ...state,
      };
  }
};
export default categoriesReducer;
